import { BookingStatusOptions } from "@/types/collections/HandlingBookingStatuses";
import { formatThousandsAndDecimalsToPercentage } from "@/lib/formatters/numbers";
import {
  RoutePairBookings,
  RoutePairData,
} from "../transformers/InvoiceSpecificationDataToHandlingTypeDataTransformer";

export const noShowLateHandlingPercentageString = (
  includedNoShowOrLateHandling: number,
  shippedUnits: number
): string => {
  return formatThousandsAndDecimalsToPercentage(
    noShowLateHandlingPercentageNumber(
      includedNoShowOrLateHandling,
      shippedUnits
    ) / 100,
    1
  );
};

export const noShowLateHandlingPercentageNumber = (
  includedNoShowOrLateHandling: number,
  shippedUnits: number
): number => {
  if (shippedUnits === 0) {
    return includedNoShowOrLateHandling > 0 ? 100 : 0;
  }

  const percentage = (includedNoShowOrLateHandling / shippedUnits) * 100;
  return percentage > 100 ? 100 : parseFloat(percentage.toFixed(1));
};

export const noExcludedBookings = (bookings: RoutePairBookings) => {
  let noExcluded = 0;
  bookings.forEach((booking) => {
    if (
      !(
        booking.handlingStatus === BookingStatusOptions.TOINVOICE ||
        booking.handlingStatus === BookingStatusOptions.TODO ||
        booking.handlingStatus === BookingStatusOptions.INVOICED ||
        booking.handlingStatus === BookingStatusOptions.THRESHOLD
      )
    ) {
      noExcluded++;
    }
  });

  return noExcluded;
};

export const getConsignmentNo = (routePairsData: RoutePairData[]) => {
  if (routePairsData.length > 0) {
    for (let routePairData of routePairsData) {
      if (routePairData.bookings.length > 0) {
        return routePairData.bookings[0].consignmentNo;
      }
    }
  }
  return null;
};
